import { useState } from 'react'
import { Fragment } from 'react/jsx-runtime'

import { DateRangePicker, FilterSeparator, FilterValue, Trackable } from '@forto-dev/phoenix-ui-core'

import { DateFilterType, dateOptionGroups, getFromToDatesByFilter } from '@/utils/dateFilters'
import { formatDateForAPI } from '@/utils/formatDateForAPI'
import { useLocalisation } from '@/utils/localisation'

type DateRangeFilterProps = {
  selectedDateFilter: DateFilterType | undefined
  selectedFromDate: Date | undefined
  selectedToDate: Date | undefined
  onChange: (filter: { dateFilter: DateFilterType; from: Date | undefined; to: Date | undefined }) => void
}

export const DateRangeFilter = ({
  selectedDateFilter,
  selectedFromDate,
  selectedToDate,
  onChange,
}: DateRangeFilterProps) => {
  const { translate } = useLocalisation()
  const [customDates, setCustomDates] = useState<{ from: Date | undefined; to: Date | undefined }>({
    from: selectedFromDate,
    to: selectedToDate,
  })

  return (
    <>
      {dateOptionGroups.map((dateOptionGroup, index) => (
        <Fragment key={dateOptionGroup.join('')}>
          {index !== 0 && <FilterSeparator />}
          {dateOptionGroup.map((option) => {
            return (
              <Trackable key={option}>
                <FilterValue
                  type="radio"
                  name="billing-date-filter"
                  value={option}
                  label={translate(`billing.filter.${option}`)}
                  selected={selectedDateFilter === option}
                  onSelect={() => {
                    const [from, to] = getFromToDatesByFilter[option]()
                    const selectedFromDateValue = formatDateForAPI(from, 'short_date') as unknown as Date
                    const selectedToDateValue = formatDateForAPI(to, 'short_date') as unknown as Date

                    onChange({
                      dateFilter: option,
                      from: selectedFromDateValue,
                      to: selectedToDateValue,
                    })
                  }}
                />
              </Trackable>
            )
          })}
        </Fragment>
      ))}
      <DateRangePicker
        disabled={selectedDateFilter !== 'custom'}
        value={customDates}
        onChange={(range) => {
          setCustomDates({
            from: range?.from,
            to: range?.to,
          })
          onChange({
            dateFilter: 'custom',
            from: formatDateForAPI(range?.from, 'short_date') as unknown as Date,
            to: formatDateForAPI(range?.to, 'short_date') as unknown as Date,
          })
        }}
      />
    </>
  )
}
